import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	submitButtonLabel: {
		id: 'software-backlog-ai-work-creation.ai-work-create-link-picker.submit-button-label',
		defaultMessage: 'Suggest work items',
		description: 'Label for the button that submits a link for work item suggestion/generation',
	},
	linkPlaceholder: {
		id: 'software-backlog-ai-work-creation.ai-work-create-link-picker.link-placeholder',
		defaultMessage: 'Find Confluence content or Loom videos',
		description: 'Label for link picker input placeholder',
	},
});
